import config from "appConfig";
import { ControlsToggleExtraContent, LayoutComponent } from "packages/lesson/dist/@types";

import deg0 from "./zc1-zc2/0deg";
import deg5 from "./zc1-zc2/5deg";
import deg10 from "./zc1-zc2/10deg";
import deg15 from "./zc1-zc2/15deg";
import deg20 from "./zc1-zc2/20deg";
import deg25 from "./zc1-zc2/25deg";
import deg30 from "./zc1-zc2/30deg";
import deg35 from "./zc1-zc2/35deg";
import deg40 from "./zc1-zc2/40deg";
import deg45 from "./zc1-zc2/45deg";
import deg50 from "./zc1-zc2/50deg";
import deg55 from "./zc1-zc2/55deg";
import deg60 from "./zc1-zc2/60deg";
import deg65 from "./zc1-zc2/65deg";
import deg70 from "./zc1-zc2/70deg";
import deg75 from "./zc1-zc2/75deg";
import deg80 from "./zc1-zc2/80deg";
import deg85 from "./zc1-zc2/85deg";
import deg89_99 from "./zc1-zc2/89-99deg";

const staticExtraContent: ControlsToggleExtraContent = [
  {
    type: "image",
    options: {
      src: `${config.ASSETS_URL}/01/12/principle/zc1-zc2-badge.svg`,
      styles: {
        width: "350px",
        height: "90px",
      },
    },
  },
];

const component: LayoutComponent[] = [
  {
    variant: "layout",
    data: {
      type: "controlsToggleExtraContent",
      options: {
        controlsPosition: "bottom",
        controls: [
          {
            type: "dropdown",
            options: {},
            items: [
              { name: "Angle of incidence θ = 0°" },
              { name: "Angle of incidence θ = 5°" },
              { name: "Angle of incidence θ = 10°" },
              { name: "Angle of incidence θ = 15°" },
              { name: "Angle of incidence θ = 20°" },
              { name: "Angle of incidence θ = 25°" },
              { name: "Angle of incidence θ = 30°" },
              { name: "Angle of incidence θ = 35°" },
              { name: "Angle of incidence θ = 40°" },
              { name: "Angle of incidence θ = 45°" },
              { name: "Angle of incidence θ = 50°" },
              { name: "Angle of incidence θ = 55°" },
              { name: "Angle of incidence θ = 60°" },
              { name: "Angle of incidence θ = 65°" },
              { name: "Angle of incidence θ = 70°" },
              { name: "Angle of incidence θ = 75°" },
              { name: "Angle of incidence θ = 80°" },
              { name: "Angle of incidence θ = 85°" },
              { name: "Angle of incidence θ = 90°" },
            ],
          },
        ],
        extraContent: [
          staticExtraContent,
          staticExtraContent,
          staticExtraContent,
          staticExtraContent,
          staticExtraContent,
          staticExtraContent,
          staticExtraContent,
          staticExtraContent,
          staticExtraContent,
          staticExtraContent,
          staticExtraContent,
          staticExtraContent,
          staticExtraContent,
          staticExtraContent,
          staticExtraContent,
          staticExtraContent,
          staticExtraContent,
          staticExtraContent,
          staticExtraContent,
        ],
        components: [
          deg0,
          deg5,
          deg10,
          deg15,
          deg20,
          deg25,
          deg30,
          deg35,
          deg40,
          deg45,
          deg50,
          deg55,
          deg60,
          deg65,
          deg70,
          deg75,
          deg80,
          deg85,
          deg89_99,
        ],
      },
    },
  },
];

export default component;
